import { CLOUDINARYBASEPATH } from '../constants';

export const buildImagePreviewFromId = id =>
  `${CLOUDINARYBASEPATH}/image/upload/q_auto,f_auto,h_200/v1/images/${id}`;

export const buildImageFromId = (id, max) => {
  // let cloudinary handle the transformation for hotspot images
  if (max === 'auto') {
    return `${CLOUDINARYBASEPATH}/image/upload/q_auto,f_auto,w_${max},c_limit/v1/images/${id}`;
  }
  return `${CLOUDINARYBASEPATH}/image/upload/q_auto,f_auto,w_${max ||
    1024},h_${max || 1024},c_limit/v1/images/${id}`;
};

export const buildAudioFromId = id =>
  `${CLOUDINARYBASEPATH}/video/upload/so_0,du_600,br_96k/audio_files/${id}`;

export const buildCloudinaryLink = ({ type = 'image', path, params }) =>
  `${CLOUDINARYBASEPATH}/${type}/upload/${params ? params + '/' : ''}${path}`;

export const buildCloudinaryURLFromMediaURL = (url, max) => {
  const width = max || 1024;
  return `${CLOUDINARYBASEPATH}/image/upload/q_auto,f_auto,w_${width},c_limit/v1/${url}`;
};
